<template>
  <div class="bind_lamp_page"></div>
</template>

<script>
import Vue from 'vue';
import { Toast, Dialog, Progress } from 'vant';
Vue.use(Toast).use(Dialog);
import http_iot from '@/assets/scripts/request'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      userInfo: {}
    };
  },
  computed: {
    clientId() {
      return this.$route.query.clientId;
    },
    isClubAdmin() {
      return this.userInfo.roles && (this.userInfo.roles.indexOf('ROLE_CLUB_ADMIN')>-1 || this.userInfo.roles.indexOf('ROLE_CLUB_CS')>-1)
    }
  },
  methods: {
    // 检查用户是否为管理员，若是则获取所能管理的俱乐部信息
    _checkUser() {
      this.$http.post('user/judgeLogin').then(res => {
        if (res.data.code === 0) {
          this.userInfo = res.data.value
          if (this.isClubAdmin) {
            this.myClubInfo = {}
            http_iot.post('/index/index/getClub').then(res => {
              this.myClubInfo = res.value
              Dialog.alert({
                title: `${this.myClubInfo.title} 管理员，你好`,
                className: 'myDialogStyle'
              }).then(() => {
                this._getDeviceStatus();
              })
            })
          } else {
            Dialog.alert({
              title: '您不是俱乐部管理员',
              className: 'myDialogStyle'
            }).then(() => {
              this._goback();
            })
          }
        } else if (res.data.code === 400401) {
          Dialog.alert({
            title: '请登录',
            className: 'myDialogStyle'
          }).then(() => {
            process.env.NODE_ENV === 'development' ?
            this.$router.replace({ name: 'login', query: { redirect: location.href }}) :
            location.replace(`/m/login?redirect=${encodeURIComponent(location.href)}`)
          })
        } else {
          Toast.fail(res.data.message);
        }
      })
    },
    // 检查当前设备配网状态，俱乐部的绑定状态
    _getDeviceStatus() {
      http_iot.post('/index/club_device_manage/bindDeviceCheck', {
        clientId: this.clientId
      }).then(res => {
        let value = res.value;
        if (!value || value.status !== 'online') {
          // 未配网 去配网
          this._deviceWiFi()
        } else if (!value.clubId) {
          // 已配网，无culb
          this._deviceBindClub()
        } else if (value.clubId===this.myClubInfo.id) {
          // 已配网，正确club
          Dialog.alert({
            title: '提示',
            message: '您已成功绑定该设备，如需重新配网，请长按按钮5秒至红灯闪烁',
            className: 'myDialogStyle'
          }).then(() => {
            this.$router.replace('/lampBindResult/1')
          })
        } else {
          // 已配网，其他club
          Dialog.alert({
            title: '提示',
            message: '该设备已绑定其他俱乐部，如需重新配网，请长按按钮5秒至红灯闪烁',
            className: 'myDialogStyle'
          }).then(() => {
            this._goback();
          })
        }
      });
    },
    // 设备连接wifi
    _deviceWiFi() {
      let _this = this
      wx.checkJsApi({
        jsApiList: ['configWXDeviceWiFi'],
        success: function(res) {
          wx.invoke('configWXDeviceWiFi', {}, function(res) {
            let err_msg = res.err_msg;
            if (err_msg == 'configWXDeviceWiFi:ok') {
              //配置成功
              // Dialog.confirm({
              //   title: 'WIFI配置成功',
              //   message: '正在将此设备绑定到您所管理的俱乐部，继续请点击确定按钮',
              //   className: 'myDialogStyle'
              // }).then(() => {
              //   _this._deviceBindClub()
              // })
              _this._deviceBindClub()
            } else {
              //配置失败
              Dialog.alert({
                title: '配网失败',
                message: '设备未能连接到wifi：' + err_msg + '  请重试！',
                className: 'myDialogStyle'
              }).then(() => {
                _this._goback();
              })
            }
          });
        }
      });
    },
    // 设备联网后，绑定到当前管理员的俱乐部
    _deviceBindClub() {
      http_iot.post('/index/club_device_manage/bindDevice', {
        clientId: this.clientId
      }).then(res => {
        if (res.data.code) {
          this.$router.replace('/lampBindResult/0')
          Toast.fail(res.data.message);
        } else {
          this.$router.replace('/lampBindResult/1')
        }
      })
    },
    _goback() {
      window.history.length > 1 ? this.$router.go(-1) : wx.closeWindow()
    }
  },
  created() {
    this._checkUser();
  }
};
</script>

<style lang='less'>

.myDialogStyle {
  .van-dialog__confirm, .van-dialog__confirm:active {
    color: #45AF60;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/clubAdmin/lampControl/bindLamp.vue